<div class="row" style="margin: 10px;" *ngIf='displayState.filterDiv'>
  <h4 style="text-align: center;">Assessment Appeals Case Status</h4>
  <h6 style="text-align: center;"><b>Search the status of a current assessment appeals case using any one of the criteria below.</b></h6>
  <br />
  <div class="row" style="margin: 10px;">
    <div class="col-md-3 offset-md-2">Fill in an item below and click the Search button.</div>
    <div class="col-md-2">
      <button class="btn btn-success btn-sm" (click)="runSearch()">Search</button>
      <button style="margin-left: 20px;" class="btn btn-sm btn-info" title="Clear search items" (click)="clearSearch()">Clear</button>
    </div>
    <div class="col-md-1 offset-md-1">
      <button class="btn btn-sm btn-link" title="Return to main menu" (click)="goHome()">Return to Menu</button>
    </div>
  </div>
  <div class="row" style="margin: 10px;">
    <div class="col-md-10 offset-md-1" style="padding: 5px;">
      <hr />
      <div class="card bg-light">
        <div class="card-body" style="background-color:#e9ecef">
          <div class="form-row">
            <div class="row">
              <div class="col-md-3" style="text-align: right;">
                <label class="col-form-label prd-label" style="padding-right: 10px;">Case Number</label>
              </div>
              <div class="col-md-3">
                <input type="text" size="30" [(ngModel)]="searchString.caseNum" (keyup.enter)="runSearch('casenum');" />
              </div>
              <div class="col-md-4">
                Format is yy-nnnn
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-3" style="text-align: right;">
                <label class="col-form-label prd-label" style="padding-right: 10px;">Assessor's Parcel Number (APN)</label>
              </div>
              <div class="col-md-3">
                <input type="text" size="30" [(ngModel)]="searchString.APN" (keyup.enter)="runSearch('apn');"  />
              </div>
              <div class="col-md-4">
                Format is nine numbers, including dashes is ok.
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-3" style="text-align: right;">
                <label class="col-form-label prd-label" style="padding-right: 10px;">Property Street Address</label>
              </div>
              <div class="col-md-3">
                <input type="text" size="30" [(ngModel)]="searchString.propStreetAddr" (keyup.enter)="runSearch('situs');"  />
              </div>
              <div class="col-md-4">
                Do not include city, e.g. 333 E Whatever St
              </div>
            </div>
            <hr />
            <div class="row" [hidden]="true">
              <div class="col-md-3" style="text-align: right;">
                <label class="col-form-label prd-label" style="padding-right: 10px;">Applicant Last Name</label>
              </div>
              <div class="col-md-3">
                <input type="text" size="30" [(ngModel)]="searchString.applicant" (keyup.enter)="runSearch('applicant');"  />
              </div>
              <div class="col-md-4">
                Or business name if applicable
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-10 offset-md-1" style="padding: 5px;">
    <footer class="main-footer" style="text-align:right; font-size:small;">
      <!-- <span >Copyright &copy; {{copyYear}} - Parodan, LLC. All Rights Reserved.</span> -->
      <span style="font-size: x-small">&nbsp; v. {{versionNumber}}</span>
    </footer>
    </div>

  </div>
</div>
<div class="row" *ngIf='displayState.workingDiv'>
  <div class="col-md-10 offset-md-1">
    <div class="card">
      <br />
      <div class="card-body">
        <div class="row" style="margin: 10px;" >
          <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row" style="margin: 10px;" *ngIf='displayState.gridDiv'>
  <br />
  <div class="col-md-10 offset-md-1">
    <div class="card">
      <div class="row">
        <div class="col-md-4 offset-2"><h4>Assessment Appeals Board Cases</h4></div>
        <div class="col-md-2 offset-1">
          <button class="btn btn-link" (click)="goSearch()"> Return to Search </button>
        </div>
      </div>
      <br />
      <div class="card-body" style="background-color:#e9ecef">
          <table class="table table-striped">
            <thead>
            <tr>
              <th></th>
              <th *ngFor="let col of cols; let i = index">
                {{col.header}}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let appCase of caseList; let i = index">
              <td>
                <button class="btn btn-link" (click)="onSelect(appCase)"> Select </button>
              </td>
              <td>{{ appCase.caseNumber }}</td>
              <!-- <td title="{{appCase.applicantName}}">{{ appCase.applicantName }}</td> -->
              <td title="{{appCase.situs}}">{{ appCase.situs }}</td>
              <td>{{ appCase.city }}</td>
              <td>{{ appCase.propNumber}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</div>
<div class="row" *ngIf='displayState.noCaseFound' style="margin-left: 10px;">
  <h4 style="text-align: center;">Assessment Appeals Case Status</h4>
  <br />
  <h6 style="text-align: center;">Sorry! No cases were found.</h6>
  <br />
  <button class="btn btn-link" (click)="goSearch()"> Return to Search Page </button>
</div>
<div class="row" *ngIf='displayState.caseDiv' style="margin: 5px;">
  <div class="row">
    <div class="col-md-8 offset-2">
      <div class="row">
        <div class="col-md-6"><h4>Assessment Appeals Case Status</h4></div>
        <div class="col-md-3 offset-1">
          <button class="btn btn-link" (click)="goSearch()"> Return to Search Page </button>
        </div>
      </div>
      <br /><br />
      <div class="row">
        <div class="col-md-2">
          <label class="col-form-label prd-label" style="padding-right: 10px;">Case Number</label>
        </div>
        <div class="col-md-4">
          <label class="col-form-label prd-label" style="padding-right: 10px; color: blue;">{{selCase.CaseNumber}}</label>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-md-2">
          <label class="col-form-label prd-label" style="padding-right: 10px;">APN</label>
        </div>
        <div class="col-md-4">
          <label class="col-form-label prd-label" style="padding-right: 10px; color: blue;">{{selCase.APN}}</label>
        </div>
      </div>
      <hr />
      <div class="row" [hidden]="true">
        <div class="col-md-2">
          <label class="col-form-label prd-label" style="padding-right: 10px;">Applicant</label>
        </div>
        <div class="col-md-4">
          <label class="col-form-label prd-label" style="padding-right: 10px;  color: blue;">{{selCase.ApplicantName}}</label>
        </div>
        <hr />
      </div>
      <div class="row">
        <div class="col-md-2">
          <label class="col-form-label prd-label" style="padding-right: 10px;">Status</label>
        </div>
        <div class="col-md-4">
          <label class="col-form-label prd-label" style="padding-right: 10px; color: blue;">{{selCase.Status}}</label>
        </div>
      </div>
      <div *ngIf='selCase.Hearing'>
        <hr />
        <div class="row">
          <div class="col-md-2">
            <label class="col-form-label prd-label" style="padding-right: 10px;">Hearing</label>
          </div>
          <div class="col-md-4">
            <label class="col-form-label prd-label" style="padding-right: 10px; color: blue;">{{selCase.Hearing}}</label>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-2">
            <label class="col-form-label prd-label" style="padding-right: 10px;">Location</label>
          </div>
          <div class="col-md-4">
            <label class="col-form-label prd-label" style="padding-right: 10px; color: blue;">{{selCase.Location}}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
